<template>
  <ContentHelpCard
    :data="item"
    :titleLink="goLink(item?.display_title)"
    :descLink="goLink(item?.display_content)"
    target="_blank"
    @click="handleClick"
  >
    <template #other>
      <div class="text-font-40 text-14 mt-[12px]">
        {{ item?.column_title }} | {{ item?.document_name }}
        <span v-if="item.update_time">
          {{ $t('zui-jin-geng-xin') }}
          {{ timeFormat(item?.update_time, 'YYYY-MM-DD HH:mm') }}
        </span>
      </div>
    </template>
  </ContentHelpCard>
  <div v-if="props.divider" class="divider"></div>
</template>

<script lang="ts" setup>
import type { IHelpSearch } from '~/api/index';
import { useTime } from '~/hooks/useTime';
import { PageKey } from '~/constants/page';
import { SearchModelType } from '~/api/interface/search';
import { trackEvent, TRACK_EVENT } from '~/utils/track';
const props = withDefaults(
  defineProps<{
    keywords?: string;
    item: IHelpSearch;
    divider?: boolean;
  }>(),
  {
    divider: true,
  },
);

const { timeFormat } = useTime();

const handleClick = () => {
  trackEvent(TRACK_EVENT.CLICK_SITE_SEARCH_RESULT_CLICK, {
    keywords: props.keywords,
    file_title: props.item.document_name,
  });
};

const goLink = (item: { text: string; anchor_point_id: number }) => {
  if (props.item.model_type === SearchModelType.ENTERPRISE_CASES) {
    return {
      name: PageKey.CASE_DETAIL,
      params: {
        id: props.item.model_id,
      },
    };
  } else if (props.item.model_type === SearchModelType.TUTORIAL) {
    return {
      name: PageKey.TUTORIAL_INFO,
      params: {
        id: props.item.model_id,
      },
    };
  } else {
    return {
      name: PageKey.HELP_CENTER_DETAIL,
      params: {
        id: `${props.item.column_id}${props.item.model_id ? `-${props.item.model_id}` : ''}`,
      },
      ...(item.anchor_point_id && {
        query: {
          target: item.anchor_point_id,
        },
      }),
    };
  }
};
</script>

<style lang="scss" scoped>
.result-item {
  @apply mt-[36px];
}
.divider {
  @apply h-[1px] bg-[var(--back-3)] mt-[24px] mb-[24px];
}
</style>
